// import i18n from '../../main';

/**
 *特斯拉股票行权
 */
 export default [
    {
        label: 'stockExerciseEmail',
        permission: 'set_email_management',
        img: true,
        icon: 'icon-shenpiliucheng',
        id:11,
        children: [
            {
            path: '/wage/teslaArrears',
            label: 'debtManagement',
            permission: 'set_email_management_debt',
            component:'',
            icon: 'icon-yonghu',
            id: 11-1
            },
            {
            path: '/wage/teslaEmali',
            label: 'mailSettings',
            permission: 'set_email_management_mailSet',
            icon: 'icon-yonghu',
            id: 11-2
            }
        ]
    }
  ]
